import '.e2{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.e3{padding-left:1.5rem;}.ssr-plugin'
import '.e4{margin:1rem 0;}.ssr-plugin'
import '.e5{color:var(--gray-700);}.ssr-plugin'
import '.e6{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="e2 e3 e4 e5 e6"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
